import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";

const UnauthLayout = () => (<>
    <Navbar />
    <div className="unauth-wrapper">
        <Outlet />
    </div>
</>
);

export default UnauthLayout;
